import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';


const title="Custom Software Development | AKHSoft";
const description = "Custom software tailored to your business goals. Scalable, secure, and cloud-ready solutions for enhanced productivity and performance.";
const keywords = "Custom Software Development, Scalable Software, Cloud Software, Secure Applications, Business Software Solutions";
const path = typeof window !== "undefined" ? window.location.pathname : "";

export default function CustomSoftwareDevelopment() {
  return (
      <>
    <SEO 
      title={title}
      description={description}
      keywords={keywords}
      path={path}
    />
    <div className="max-w-6xl mx-auto px-4 py-10 space-y-14">
      {/* Page Title */}
      <section className="text-center">
        <h1 className="text-4xl font-bold text-[#0a3c6d] mb-4">
          Custom Software Development
        </h1>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          We turn your unique ideas into scalable, secure, and high-performance custom applications tailored specifically to your business needs.
        </p>
      </section>

      {/* Why Custom Software */}
      <section className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h2 className="text-2xl font-semibold text-[#0a3c6d] mb-4">
            Why Choose Custom Software?
          </h2>
          <ul className="space-y-3 text-gray-700 list-disc list-inside">
            <li>Built specifically for your business workflows and goals</li>
            <li>More secure, flexible, and scalable than off-the-shelf solutions</li>
            <li>Improves efficiency, productivity, and long-term cost savings</li>
            <li>Seamless integration with existing tools and databases</li>
          </ul>
        </div>
        <img
          src="/assets/custom-software.svg"
          alt="Custom software illustration"
          className="w-full max-w-md mx-auto"
        />
      </section>

      {/* Key Features */}
      <section>
        <h2 className="text-2xl font-semibold text-[#0a3c6d] text-center mb-8">
          What We Offer
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          <FeatureCard
            title="Business-Centric Design"
            desc="Software designed to match your specific business logic and user needs."
          />
          <FeatureCard
            title="Cloud-Ready Solutions"
            desc="Easily scalable systems built with cloud-native technologies."
          />
          <FeatureCard
            title="High Performance & Security"
            desc="Optimized and secure coding practices to ensure top-notch quality."
          />
        </div>
      </section>

      {/* Our Process */}
      <section>
        <h2 className="text-2xl font-semibold text-[#0a3c6d] text-center mb-8">
          Our Development Process
        </h2>
        <div className="grid md:grid-cols-4 gap-6 text-center">
          {[
            'Requirement Gathering',
            'UI/UX Design',
            'Agile Development',
            'Testing & Deployment',
          ].map((step, index) => (
            <div
              key={index}
              className="p-5 border rounded-lg shadow-sm bg-white hover:shadow-md transition"
            >
              <span className="text-3xl font-bold text-[#0a3c6d]">{index + 1}</span>
              <p className="mt-2 text-gray-700">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="text-center bg-[#0a3c6d] text-white py-10 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold mb-3">
          Ready to Build Your Custom Software?
        </h3>
        <p className="mb-5">Let our expert team help you build a solution that gives you a competitive edge.</p>
        <Link
          to="/contact-us"
          className="inline-block bg-white text-[#0a3c6d] px-6 py-2 rounded-full font-medium hover:bg-gray-200"
        >
          Request a Free Consultation
        </Link>
      </section>
    </div>
    </>
  );
}

// Feature Card Component
function FeatureCard({ title, desc }) {
  return (
    <div className="p-5 border rounded-xl bg-white shadow-sm hover:shadow-md transition">
      <h3 className="text-xl font-semibold text-[#0a3c6d] mb-2">{title}</h3>
      <p className="text-gray-600">{desc}</p>
    </div>
  );
}
